<!-- 页面头部 -->
<template>
    <div>
      <div class="Title_Info_box">
        <el-row class="title_head" :style="'background-color:'+bgClose">
          <span class="class_img">
            <el-image class="title_img" :src="titleImg"></el-image>
          </span>
          <span>{{title}}</span>
          <i class="el-icon-close" v-if="showClose" @click="closePage" style="float: right;font-size: 24px;cursor: pointer;"></i>
        </el-row>
        <el-divider></el-divider>
      </div>
    </div>
</template>
<script>

export default {
  name: 'TitleInfo',
  props: {
    title: { //标题名称
      type: String,
      require:true,
    },
    titleImg: { //图标地址
      type: String,
      require:true,
    },
    bgClose: { //背景色
      type: String,
      default: function(){
        return "";
      }
    },
    showClose: { //是否显示关闭按钮
      type: Boolean,
      default: function(){
        return true;
      }
    },
  },
  data() {
    return {
      rlen:history.length
    }
  },
  methods: {
    closePage(){ //返回
      // this.$router.go(-1);
      let len = this.rlen - history.length - 1;//-1是不进入iframe页面的下级页面直接退出的话，执行后退一步的操作
      this.$router.go(len);
    }
  }
};
</script>
<style  lang="less">
  .Title_Info_box{
    .title_head{
      padding: 10px 20px;
    }
    .title_img{
      width: 24px !important;
      float: left;
    }
    .class_img{
      float: left;margin-right: 10px;
    }
    .el-divider--horizontal{
      margin: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TitleInfo.vue